export default {
  metaTitle: "USFans Spreadsheet 2026 : trouvailles complètes et guide d'achat",
  metaDescription:
    "Découvrez la USFans Spreadsheet : trouvailles organisées, navigation par catégories, guides d'achat, conseils QC et infos d'expédition. Indépendante et à jour.",
  heroEyebrow: "LE HUB DE RESSOURCES USFANS SPREADSHEET",
  heroH1: "USFans Spreadsheet — découvrez des trouvailles, comparez et achetez mieux",
  heroSub:
    "Explorez les ressources USFans Spreadsheet les plus récentes, les trouvailles utiles, les guides d'achat, les conseils QC, les infos d'expédition, les avis et les conseils de sécurité — le tout réuni dans un hub facile à utiliser.",
  heroCta1: "USFans Spreadsheet",
  heroCta2: "Acheter maintenant",
  heroTrust: "Ressource indépendante · Guides à jour · Infos d'achat pratiques",
  heroBadge: "Point de départ fiable pour les trouvailles USFans",
  categoriesH2: "Parcourir les catégories de produits",
  categoriesSub:
    "Accédez directement à la section souhaitée sur le site principal. Choisissez une catégorie ci-dessous ou utilisez le menu déroulant ci-dessus.",
  categoriesGridH2: "Acheter par catégorie",
  categoriesGridSub: "Chaque catégorie mène directement aux produits USFans correspondants sur le site principal.",
  viewCategory: "Voir",
  valuePropsH2: "Tout ce qu'il faut savoir sur USFans",
  valuePropsSub: "Un hub unique pour les sujets les plus demandés par les acheteurs — expliqués simplement.",
  vp1Title: "USFans Spreadsheet",
  vp1Desc: "Découvrez des trouvailles utiles et des ressources produits organisées au même endroit.",
  vp1Cta: "Explorer la feuille",
  vp2Title: "Avis USFans",
  vp2Desc: "Comprenez la plateforme, ses fonctions, les risques potentiels et les points importants.",
  vp2Cta: "Lire l'avis USFans",
  vp3Title: "Expédition",
  vp3Desc: "Comprenez les méthodes d'expédition, les coûts estimés et le suivi.",
  vp3Cta: "Voir le guide d'expédition",
  vp4Title: "QC",
  vp4Desc: "Apprenez quoi vérifier avant d'approuver des produits et de confirmer une commande.",
  vp4Cta: "Apprendre le QC",
  vp5Title: "Sécurité",
  vp5Desc: "Découvrez des moyens pratiques de réduire les risques d'achat courants.",
  vp5Cta: "Visiter le centre de sécurité",
  vp6Title: "Entrepôt",
  vp6Desc: "Comprenez comment fonctionnent le stockage et le traitement des commandes.",
  vp6Cta: "Lire le guide de l'entrepôt",
  seoH2: "Pourquoi utiliser la USFans Spreadsheet ?",
  seoP1:
    "La USFans Spreadsheet rassemble la découverte de produits en un seul endroit clair. Au lieu de sauter entre des liens dispersés et des pages obsolètes, vous pouvez parcourir des catégories organisées, comparer des trouvailles similaires et aller directement sur le site principal lorsque vous êtes prêt à acheter. Elle est conçue pour vous faire gagner du temps et réduire les incertitudes des achats en ligne.",
  seoP2:
    "Nous gardons ce hub indépendant et facile à utiliser. Vous y trouverez des ressources pratiques sur les catégories, les contrôles qualité, l'expédition et la sécurité — écrites simplement et mises à jour régulièrement. Que vous cherchiez des chaussures, des sweats, des sacs ou des accessoires, la feuille vous donne un point de départ clair.",
  seoList1: "Catégories organisées pour naviguer plus vite",
  seoList2: "Des conseils d'achat clairs",
  seoList3: "Les bases du QC, de l'expédition et de la sécurité",
  seoList4: "Des ressources mises à jour régulièrement",
  seoReadMore: "Lire le guide complet",
  seoCardTitle: "USFans Spreadsheet 2026 : guide complet",
  seoCardDesc:
    "Ce qu'est la feuille, comment elle fonctionne, les catégories principales et comment acheter avec plus de confiance — dans un guide détaillé.",
  faqH2: "Questions fréquentes",
  faq1Q: "Qu'est-ce que la USFans Spreadsheet ?",
  faq1A:
    "C'est une ressource organisée qui regroupe les trouvailles USFans par catégorie, pour parcourir et comparer les produits au même endroit.",
  faq2Q: "La USFans Spreadsheet est-elle gratuite ?",
  faq2A:
    "Oui — parcourir la ressource est gratuit. Vous ne payez que lorsque vous décidez d'acheter via le site principal.",
  faq3Q: "Comment accéder aux produits ?",
  faq3A:
    "Choisissez une catégorie dans le menu déroulant ou les cartes, et vous serez redirigé vers la section correspondante du site principal.",
  finalCtaH2: "Prêt à explorer la USFans Spreadsheet ?",
  finalCtaSub: "Parcourez des trouvailles organisées, comparez les catégories et achetez mieux — au même endroit.",
  finalCtaPrimary: "Explorer la USFans Spreadsheet",
  finalCtaSecondary: "Visiter le site principal",
  pillarH2: "Articles piliers et guides",
  pillarSub: "Nos ressources USFans les plus lues — avis, expédition, QC, sécurité et conseils d'achat réunis.",
  pillarRead: "Lire le guide",
  p1Title: "Avis USFans 2026",
  p1Desc: "USFans est-il légitime et sûr ? Un aperçu simple de son fonctionnement et des points à vérifier.",
  p2Title: "Guide des frais d'expédition USFans",
  p2Desc: "Ce qui influence le prix d'expédition et comment comparer les options avant de commander.",
  p3Title: "Guide des coupons USFans",
  p3Desc: "Comment fonctionnent les coupons et où vérifier les promotions en toute sécurité.",
  p4Title: "Guide des codes promo USFans",
  p4Desc: "Comment trouver et vérifier les codes promo actuels avant d'acheter.",
  p5Title: "Guide de l'entrepôt USFans",
  p5Desc: "Comment fonctionnent le stockage, le QC et le traitement des commandes.",
  p6Title: "USFans est-il légitime ?",
  p6Desc: "Un regard équilibré sur la confiance, les risques et la protection de l'acheteur.",
  p7Title: "Guide QC USFans",
  p7Desc: "Ce qu'il faut inspecter avant d'approuver des produits et de confirmer une commande.",
  p8Title: "Guide d'achat USFans",
  p8Desc: "Un parcours étape par étape pour commander avec plus de confiance.",
  p9Title: "Centre de sécurité USFans",
  p9Desc: "Des moyens pratiques de réduire les risques d'achat les plus courants.",
  p10Title: "Suivi et expédition USFans",
  p10Desc: "Comprendre les bases du suivi et de l'expédition de vos commandes.",
};